$(window).on(function() {
    $(".loader").fadeOut("slow");
});
var jq = $.noConflict(true);
jq(function() {
    jq(".select2bs4").select2({
        theme: "bootstrap4"
    });
});

jq(document).ready(function() {
    function loadCiudades() {
        jq(".loader").show();
        var departamento_id = jq("#departamento").val();
        jq("#ciudad_id").empty();
        jq("#ciudad_id").append("<option value=''>Seleccione uno</option>");
        if (jq.trim(departamento_id) != "") {
            jq.get("/ciudad/" + departamento_id, function(response, state) {
                var old =
                    jq("#ciudad_id").data("old") != ""
                        ? jq("#ciudad_id").data("old")
                        : "";
                jq.each(response, function(index, value) {
                    jq("#ciudad_id").append(
                        "<option value='" +
                            value.IdCiudad +
                            "' " +
                            (old == value.IdCiudad ? "selected" : "") +
                            ">" +
                            value.Nombre +
                            "</option>"
                    );
                });
            });
        }
        jq(".loader").fadeOut("slow");
    }
    loadCiudades();
    jq("#departamento").on("change", loadCiudades);
});



jq(function() {
    jq("#formularioForm").validate({
        ignore: ".ignore",
        validateHiddenInputs : true,
        rules: {
            nombre: {
                required: true,
                maxlength: 255,
                normalizer: function(value) {
                    return $.trim(value);
                }
            },
            departamento: {
                required: true
            },
            ciudad_id: {
                required: true
            },
            autorizacion_id: {
                required: true
            },
            establecimiento_id: {
                required: true
            },
            direccion: {
                maxlength: 255
            },
            pagina: {
                url: true
            },
            telefono: {
                required: true,
                maxlength: 255,
                normalizer: function(value) {
                    return $.trim(value);
                }
            },
            email: {
                required: true,
                email: true,
                maxlength: 255,
                normalizer: function(value) {
                    return $.trim(value);
                }
            },
            categoria_id: {
                required: true
            },
            conoce_programa_id: {
                required: true
            },
            nit: {
                required: true,
                maxlength: 255,
                normalizer: function(value) {
                    return $.trim(value);
                }
            },
            logo: {
                required: true,
                extension: "jpg,jpeg,png",
                maxsize: 5000000
            },
            registro_camara: {
                required: true,
                extension: "pdf",
                maxsize: 5000000
            },
            registro_nacional_turismo: {
                required: true,
                extension: "pdf",
                maxsize: 5000000
            },
            registro_unico_tributario: {
                required: true,
                extension: "pdf",
                maxsize: 5000000
            },
            documento_identidad: {
                required: true,
                extension: "pdf",
                maxsize: 5000000
            },
            descripcion: {
                required: true,
                maxlength: 200,
                normalizer: function(value) {
                    return $.trim(value);
                }
            },
            hiddenRecaptcha: {
                required: function() {
                    if (grecaptcha.getResponse() == "") {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            nombre: {
                required: "Por favor ingrese un nombre",
                maxlength: "El máximo de caracteres permitido es de 255"
            },
            departamento: {
                required: "Por favor seleccione un departamento"
            },
            ciudad_id: {
                required: "Por favor seleccione una ciudad"
            },
            autorizacion_id: {
                required: "Por favor seleccione una opción"
            },
            establecimiento_id: {
                required: "Por favor seleccione un tipo de establecimiento"
            },
            direccion: {
                maxlength: "El máximo de caracteres permitido es de 255"
            },
            pagina: {
                url:
                    "Por favor ingrese una url válida, por ejemplo https://google.com/"
            },
            telefono: {
                required: "Por favor ingrese un número telefónico",
                maxlength: "El máximo de caracteres permitido es de 255"
            },
            email: {
                required: "Por favor ingrese un número telefónico",
                email: "Por favor ingrese un correo eletrónico válido",
                maxlength: "El máximo de caracteres permitido es de 255"
            },
            categoria_id: {
                required: "Por favor seleccione una categoría"
            },
            conoce_programa_id: {
                required: "Por favor seleccionar una opción"
            },
            nit: {
                required: "Por favor ingrese el nit",
                maxlength: "El máximo de caracteres permitido es de 255"
            },
            logo: {
                required: "Por favor cargue el logo",
                extension: "Los formatos válidos son jpg, jpeg y png",
                maxsize: "El tamaño máximo permitido es de 5MB"
            },
            registro_camara: {
                required: "Por favor cargue el Registro en Cámara de Comercio",
                extension: "El formáto válido es pdf",
                maxsize: "El tamaño máximo permitido es de 5MB"
            },
            registro_nacional_turismo: {
                required: "Por favor cargue el Registro nacional de turismo",
                extension: "El formáto válido es pdf",
                maxsize: "El tamaño máximo permitido es de 5MB"
            },
            registro_unico_tributario: {
                required: "Por favor cargue el Registro único tributario",
                extension: "El formáto válido es pdf",
                maxsize: "El tamaño máximo permitido es de 5MB"
            },
            documento_identidad: {
                required: "Por favor cargue el Documento de identidad",
                extension: "El formáto válido es pdf",
                maxsize: "El tamaño máximo permitido es de 5MB"
            },
            descripcion: {
                required: "Por favor ingrese una descripción",
                maxlength: "El máximo de caracteres permitido es de 200"
            },
            hiddenRecaptcha: {
                required: "Por favor realice la validación del captcha"
            }
        },
        submitHandler: function(form) {
            jq("#confirmDialog").modal("show");
            jq("#SubForm").on("click", function() {
                jq(".loader").fadeOut("slow");
                form.submit();
            });
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            error.addClass("invalid-feedback");
            element.closest(".form-group").append(error);
        },
        highlight: function(element, errorClass, validClass) {
            console.log(element);
            jq(element).addClass("is-invalid");
            jq("#" + jq(element).attr("id") + "Help").hide();
            jq(element)
                .next(".text-muted")
                .hide();
        },
        unhighlight: function(element, errorClass, validClass) {
            jq(element).removeClass("is-invalid");
            jq(element)
                .next(".text-muted")
                .show();
        }
    });
});
